import { useRouter } from 'next/router';
import ErrorPage from 'next/error';
import {
  NextPage,
  GetStaticProps,
  GetServerSideProps,
  GetStaticPaths,
} from 'next';
import Head from 'next/head';
import BlogPage from '../../components/BlogPage';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { getAllPostsWithSlug, getPostAndMorePosts } from '../../lib/graphcms';
import { Post } from '../../types/api';

interface PageProps {
  post: Partial<Post>;
  morePosts: Post[];
  preview: boolean;
}

const Page: NextPage<PageProps> = ({ post, morePosts }) => {
  const router = useRouter();

  if (!router.isFallback && !post?.slug) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      {router.isFallback ? (
        <h1>Loading…</h1>
      ) : (
        <>
          <Head>
            <title>
              {post.title}
            </title>
            <meta property="title" key="title" content={`${post.title}` as string} />
            <meta property="description" key="description" content={post.excerpt} />
            <meta property="og:image" key="og:image" content={post.coverImage?.url} />
            <meta property="og:title" key="og:title" content={post.title} />
            <meta property="og:description" key="og:description" content={post.excerpt} />
            <meta property="og:url" key="og:url" content={`https://ashourguitar.com/blog/${post.slug}`} />
            <meta property="og:type" content="article" />
          </Head>
          <BlogPage post={post} morePosts={morePosts} />
          <Footer />
        </>
      )}
    </>
  );
};

export const getServerSideProps: GetServerSideProps<{
  preview: boolean;
  post: Partial<Post>;
  morePosts: Partial<Post>[];
}, {
  slug: string;
}> = async (
  { params, preview = false },
) => {
  const data = await getPostAndMorePosts(params ? params.slug : '', preview);
  return {
    props: {
      preview,
      post: data.post,
      morePosts: data.morePosts || [],
    },
  };
};

// export const getStaticProps: GetStaticProps<{
//   preview: boolean;
//   post: Partial<Post>;
//   morePosts: Partial<Post>[];
// }, {
//   slug: string;
// }> = async (
//   { params, preview = false },
// ) => {
//   const data = await getPostAndMorePosts(params ? params.slug : '', preview);
//   return {
//     props: {
//       preview,
//       post: data.post,
//       morePosts: data.morePosts || [],
//     },
//   };
// };

// export const getStaticPaths: GetStaticPaths = async () => {
//   const posts = await getAllPostsWithSlug();
//   return {
//     paths: posts.map((post) => ({
//       params: { slug: post.slug as string },
//     })),
//     fallback: true,
//   };
// };

export default Page;
